import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IPortalNoteModel } from '@apps-common/types/portal/portal-note'

export const getPortalNote = async (noteId: number): Promise<IPortalNoteModel> =>
  axios.get(`/portalnotes/getnote?noteId=${noteId}`).then((res) => res.data?.data)

type QueryFnType = typeof getPortalNote

type Props = {
  config?: QueryConfig<QueryFnType>
  noteId: number
}

export const useGetPortalNote = ({ config, noteId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getPortalNote', noteId],
    queryFn: () => getPortalNote(noteId)
  })
